import api from './api';

export async function getRestaurants({ page = 1, limit = 20, status, search, sort = 'newest' } = {}) {
  const params = { page, limit, sort };
  if (status) params.status = status;
  if (search) params.search = search;
  const response = await api.get('/admin/restaurants', { params });
  return response.data;
}

export async function createRestaurant(payload) {
  const response = await api.post('/admin/restaurants', payload);
  return response.data;
}

export async function getRestaurantById(restaurantId) {
  const response = await api.get(`/admin/restaurants/${restaurantId}`);
  return response.data;
}

export async function updateRestaurant(restaurantId, payload) {
  const response = await api.patch(`/admin/restaurants/${restaurantId}`, payload);
  return response.data;
}

export async function deleteRestaurant(restaurantId) {
  const response = await api.delete(`/admin/restaurants/${restaurantId}`);
  return response.data;
}
